module.exports = {
  url: "/api",

  //NOTE: For production use window.location.origin + "/sharing/url"
  // shareUrl: "http://localhost:3000/sharing/url",  // --> for development testing
  shareUrl: window.location.origin + "/sharing/url",

  /*------------------------------------------------------------
        socket server URL
        change socket server URL when deploying to production
      -------------------------------------------------------------*/
  //socketUrl: "https://climate-rx.herokuapp.com",
  socketUrl: "/",

  //api to access server outes
  //url:"https://climate-rx.herokuapp.com/api",
  quest_url: "https://www.mapquestapi.com/geocoding/v1/reverse?",
  quest_api: "kl7QduGwCfoZKIZUN0pItbGEhoG3VtfX",
};
